import { render, staticRenderFns } from "./winebrand.vue?vue&type=template&id=c5a863d4&scoped=true&"
import script from "./winebrand.vue?vue&type=script&lang=js&"
export * from "./winebrand.vue?vue&type=script&lang=js&"
import style0 from "./winebrand.vue?vue&type=style&index=0&id=c5a863d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a863d4",
  null
  
)

export default component.exports